import Link from "next/link";

// The .page-title-area hero the blog views used above their content.

export default function PageTitle({ title, crumb }: { title: string; crumb: string }) {
  return (
    <div className="page-title-area page-title-four">
      <div className="d-table">
        <div className="d-table-cell">
          <div className="page-title-item">
            <h1 style={{ color: "white", fontWeight: 600 }}>{title}</h1>
            <ul>
              <li>
                <Link href="/">Home</Link>
              </li>
              <li>
                <i className="icofont-simple-right" />
              </li>
              <li>{crumb}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
